import { HTTP_INTERCEPTORS } from '@angular/common/http';
import { type Provider } from '@angular/core';

import { AuthInterceptor } from './auth-interceptor';
import { ValidationTokenInterceptor } from './validation-token-interceptor';
import { ErrorNotificationInterceptor } from './validation-error-interceptor';

/** Http interceptor providers. */
export const httpInterceptorProviders: Provider[] = [
	{ provide: HTTP_INTERCEPTORS, useClass: AuthInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: ValidationTokenInterceptor, multi: true },
	{ provide: HTTP_INTERCEPTORS, useClass: ErrorNotificationInterceptor, multi: true },
];
